export default "__VITE_ASSET__hDOteaQ4__"